import { render, staticRenderFns } from "./GroupSync.vue?vue&type=template&id=d041b72c"
import script from "./GroupSync.vue?vue&type=script&lang=ts"
export * from "./GroupSync.vue?vue&type=script&lang=ts"
import style0 from "./GroupSync.vue?vue&type=style&index=0&id=d041b72c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports